// Chart colours for recharts, which needs literal values: the Heda design
// tokens (design/README.md) plus the Tailwind status scales.
export const C = {
  ink: '#1C1A14',
  sub: '#5E594C',
  mute: '#8B8578',
  line: '#E8E1D0',
  gold: '#B8860B',
  olive: '#8C9A5F',
  oliveDark: '#6F7C47',
  emerald: '#047857', // emerald-700
  amber: '#F59E0B',   // amber-500
  red: '#B91C1C',     // red-700
  sky: '#0369A1',     // sky-700
};

// Categorical series, in order of use.
export const SERIES = [C.olive, C.gold, C.ink, C.oliveDark, C.mute, C.sky, C.amber, C.emerald, C.red];

// Shared axis / grid / tooltip props.
export const AXIS_TICK = { fontSize: 10, fill: C.mute };
export const GRID = { strokeDasharray: '3 3', stroke: C.line, vertical: false };
export const TOOLTIP_STYLE = { fontSize: '12px', borderRadius: '12px', borderColor: C.line };
